// extracted by mini-css-extract-plugin
export default {"googleButton":"GoogleLogin_googleButton__OihaN","signupVariant":"GoogleLogin_signupVariant__eporr","googleIcon":"GoogleLogin_googleIcon__em5Vt"};